import { Link } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";
import Page from "../components/Page";
import Hero from "../components/Hero";
import heroImage from "../assets/images/homepro-desktop-2.png";
import heroImageMobile from "../assets/images/homepro-mobile-2.png";
import ImageCopy from "../components/ImageCopy";
import imgCol from "../assets/images/Group-2000004157.png";
import dashboardImg from "../assets/images/Home-Pro-dashboard.png";
import TestimonialsBlock from "../components/TestimonialsBlock";
import CtaBlock from "../components/CtaBlock";
import { Col, Container, Row } from "react-bootstrap";
import stepsDesktop from "../assets/images/steps-desktop.png";
import stepsMobile from "../assets/images/steps-mobile.png";
import { useState, useEffect } from "react";
import stepsMobile3 from "../assets/images/steps-moble-3.png";
import lifetimeWindowsLogo from "../assets/images/partnerLogos/Lifetime-windows.png";
import lifetimeShowerLogo from "../assets/images/partnerLogos/Lifetime-shower.png";
import gsLogo from "../assets/images/partnerLogos/GS_Exterior_Expoerts_logo.png";
import helixLogo from "../assets/images/partnerLogos/Helix-painting.png";
import bellLogo from "../assets/images/partnerLogos/bell.png";
import cciLogo from "../assets/images/partnerLogos/CCI_logo.png";
import grcBuildersLogo from "../assets/images/partnerLogos/GRCBuilders.png";
import mightyLogo from "../assets/images/partnerLogos/Mighty_Plumbing_Logo.png";
import deckTecLogo from "../assets/images/partnerLogos/DeckTec_Logo.png";
import redcastleLogo from "../assets/images/partnerLogos/redcastle-builders.png";
import applewoodLogo from "../assets/images/partnerLogos/Applewood_Plumbing.png";
import everstoneLogo from "../assets/images/partnerLogos/EverStone_Logo.png";

const Contractor = () => {
  usePageTitle("Contractor");
  const logos = [
    lifetimeWindowsLogo,
    lifetimeShowerLogo,
    gsLogo,
    helixLogo,
    bellLogo,
    cciLogo,
    grcBuildersLogo,
    mightyLogo,
    deckTecLogo,
    redcastleLogo,
    applewoodLogo,
    everstoneLogo,
  ];

  const [width, setWidth] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    handleResize();
    setTimeout(() => {
      handleResize();
    }, 1000);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageHouseData =
    "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";
  const imageGlassData =
    "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";
  const imagePointerData =
    "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";
  const imageCheckmarkData =
    "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALUSURBVHgBvVdNUhpREP7eG8yPViUcwdwAl8kmZJmVsDBCNoETCKKVpbhM0ARPACwiFYuqcIPgJmYHN5AjYKqiVcLMS/ebUDIyvzr4VVHMm2nm+7pfd79GICxK7VUsGeuAStMqBSWSdJ3UzwSGtB7SugdlneIw3wv7WhFoUWmnIYy9/8Rh3zqkTxWfN1vBpl74SB6bRiMSsZsQab3Bp/zQy0S63q0cZ4i8fy9yhgI5Ic9R+V71MjHm7myfFCBFm66eIC4IpPFyQ+Cs04OvAPbcJo8fHiJucoD33JI/ddgWCUU5MVMlNzlgGV8XTq4ZZQOlRtIpYLddgFIZPATYycTyllOAMj4gdoiRz8PSNApS7/19y20eVUzMNfJ26PE8icdPX9sCLG6vMUKpJg4291Gn5iNFz9NugowtAFQesZGTx+ZVWV9z81Gq4G0s0raAuDJfk1OJ1Ysj3U8E9nztBfFSHlAEVAqxwCzrsHNOSSrpMDCePZeBRkKVIIRfQjGqOHzf1ZkdpZlJc9VfAJOOr1qovRvo8LqJmCYdY2klYjMbX0h9ZHqB92lpua/DyuE1H61RNLoOgaGTzo3/ekgREANfI/aIw7r7LYV6dkTRyIJDHjXp5jHi31IVqEGgKYtQiT52jkt6zSHX5BGTzvlSzSv1DBcaRDQdLpg8atI5+EWTv+zjeOekH6kcBboYXxbtpIu471NMrBfshF0FlnkU5bfkcQaJlfM7k3Pl1O050RbwJd8MqHO3tyRxJ9Apaar96WqmD1hFPASEVZ167xTAY5KlylgoVB21nGO7nUPpWec3Xm3wVRrxY4CDXPb2zfmx/FfnNHYRgtt17q3bI/ezgBuNQjZ6Ys4xj/RhVst55pf/f8PSjyQS11skpKDPhSjEvN+TyyPdqv0sERbbNDkbch0W/TN2FaO97dF3D+O/rSDi6AJmwS2Yhgk+z2mmpEPpz0VYwtv4Bx/UK+BB8E3XAAAAAElFTkSuQmCC";
  const imageXData =
    "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANrSURBVHgBtVdNUhpBFH49A8ouHGGOoCcI7JKNwgmExKTKlXgCzQkkK6uS6OgqS1PmAOIuO72BHAGLjTAz3fleM4PodM80hrwqYKp5/f7f994IcqSwVgtoOt0mIRqk1IYSoo5j/pBQaojzIc4H5Hk33TgeuMoVZQxhpcIKDxVRg9xpiM/RhyS5KGO0GqA9jqJwScU5QybVanPv8XFoY/BMhz98v6Wi6PYflTMF61F0f1qpHNkY/JcHp9Vqx1PqJx5rtCJCmBtbvi+upBxQkQHseap85WQzYl4DnHOE/RqPAf1HSoRoflrokqcaiKJjm3KlVB8/I3Ik8J/b+H2lwjBt37kBp77fQcG1bMo/SnkAy9vkpvwI/F2RJJsWlgBYsf/MAHzt2AQKIVonSA+HDcIPqJgGUP5FG+L7PRsTQKyXRcHTuS9ut2B9Or3kCxDeZw/NUtUQXusopW23XyCzDgPfagM0vJaREBvS90N+ZA/TmnimfCJls4u8o417gObDMpFZyj2N7Q6EdmnBs+PUCE7FIPsvlrK9B9T7Vq1uCClLlWt5SjW0AfAmIEfCpV6Gajrc8Fzi7DPRHaeyIuUlLVR4sTARcFrFme8rWpIkUWcXg4YFcNjDer2uxuNbWhJDZJIEHr2CcKl/AmXdrNfHYyuGlMh5nQEI/ai2ADSxEKVj10Qx0YOnl4nllC9WfGcJjMhRFYXLXXDnfAOes3KueF5UUPGhE0aYacROeBDqbIAUoquVM3gB0/XhDCOy9mQUdE2H1uvF2OFcuNk7VP4v09QERnSy9sQa1nF06lwboEdjyYV0IM0wPo4vyVDxjH5zjECaqKS2JkmiHdddgOHwtYB3kCIfATP6vBHbGNkILDU7nFtthGUk87jemy2uTwvJmefdMzoZuO8ma2vttTjuuGA8K0Vam5j7LSP/rJA3cwZ8R1Xj0rVFKDMH5E7suRGSGbp3pZxHfL4T/pZyuCXEA+b/O8M9N3x/IuNCy7W0m9ZSzgCmK6X+wAheQhq0akIqUUu5rSq3lsOIm1UbwUUH5e9N/xlnAbccJl6bloXpvOYR55x3RBtL4bshQ6zEAslAY+yQAsWY8X0PxdYt2aZLX04z4s0ZP9uCccDcriPgycDjN2QpL7qOa7yzAYvEkUmI3vA8R6qGKKQHV4Uv6S+lSNoGBHSRxgAAAABJRU5ErkJggg==";

  return (
    <section>
      {/* <Page slug='become-a-home-pro' /> */}
      <Hero
        header={
          <>
            <span>Real </span>
            Connections, <br/>
            <span>Fair </span>
            Opportunities, <br/>
            <span>No Lead Fees.</span>
          </>
        }
        subheader={
          "Tired of wasting time and money? Say goodbye to oversold leads and exorbitant lead fees as an ImproveYourHouse Home Pro."
        }
        image={heroImage}
        mobileImage={heroImageMobile}
        link="https://improveyourhouse.com/register-home-pro"
        linkText="Become a Home Pro"
        videoUrl="https://media.watermarkadvertising.net/iyh/IYH_Commercial_Home%20Pro_Option%202_30%20sec.mp4"
      />

      <div className={"how-homeowners-choose-wrapper"}>
        <div className={"how-homeowners-choose-title"}>
          <em>
            How Homeowners choose <strong>YOU!</strong>
          </em>
        </div>
        <div className="columns-3">
          <div className="column">
            <img src={`data:image/png;base64,${imageHouseData}`} />
            <div>Homeowners join ImproveYourHouse.com for FREE.</div>
          </div>
          <div className="column">
            <img src={`data:image/png;base64,${imageGlassData}`} />
            <div>
              Using our online directory, homeowners search locally for the Home
              Pro they need.
            </div>
          </div>
          <div className="column">
            <img src={`data:image/png;base64,${imagePointerData}`} />
            <div>
              If your Home Pro account matches their needs and location, they
              can send you their project details or contact directly!
            </div>
          </div>
        </div>
      </div>

      <ImageCopy
        imagePos="left"
        image={imgCol}
        headline="Fed Up with Oversold Leads and Missed Opportunities?"
        subhead="Ditch B.S. Leads—Join Home Pro, Get to Work with ImproveYourHouse.com today!"
        copy={
          <div>
            <p>
              When you become an ImproveYourHouse Home Pro, you're not just
              joining a list—you're stepping into an exclusive directory of
              A-List home improvement contractors.
            </p>
            <ul>
              <li>
                <span>Ditch surprise lead fees</span>—-You shouldn't have to pay
                for oversold or outdated leads!
              </li>
              <li>
                <span>Skip cold-calling</span>. Homeowners contact you directly,
                so you can get to work faster.
              </li>
              <li>
                <span>Showcase your business</span>—-Professionally designed
                profile and marketing support.
              </li>
            </ul>
          </div>
        }
        ctaButton={{
          to: "https://improveyourhouse.com/register-home-pro",
          linkText: "Become a Home Pro",
        }}
      />

      <div className={"compareTableWrapper"}>
        <table className={"comparison-table"}>
          <thead>
            <th className="comparison-table-title">FEATURES</th>
            <th className="conparison-table-site">ImproveYourHouse</th>
            <th className="conparison-table-site">"The Other Guys"</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class={"text-blue"}>
                  Low, Fixed Monthly Subscription Fee:
                </span>
                <br />
                Pay a simple, predictable monthly fee.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>
                  Homeowners Reach Out to You:
                </span>
                <br />
                No more cold calling—homeowners contact you directly.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>
                  Real Opportunities: Get genuine,
                </span>
                <br />
                up-to-date leads without extra charges.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>Real-Time Analytics: </span>
                Track your leads, profile visits, website clicks, calls,
                favorite status and more.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>
                  Dedicated In-House Marketing and Design Team:
                </span>{" "}
                Stand out with expert support included.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>Upfront Marketing Options: </span>
                Choose from various upgraded options and tiers to boost your
                marketing.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>Exclusive Print Magazine: </span>
                Advertise in our high-end magazine delivered to top-earning
                homeowners in your service areas.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>Poor Leads: </span>No oversold,
                outdated, or unreliable leads that waste your time and money.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>Fight for Refunds: </span>Waste
                your valuable time demanding lead fee refunds or credits.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>Constant Rebranding: </span>
                Confuses homeowners, erodes credibility.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
            </tr>
            <tr>
              <td>
                <span className={"text-blue"}>
                  Contractors Pay to Chase Leads:{" "}
                </span>
                You're on your own when reaching out to leads, often never
                making contact.
              </td>
              <td>
                <img src={`data:image/png;base64,${imageXData}`} />
              </td>
              <td>
                <img src={`data:image/png;base64,${imageCheckmarkData}`} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        className="step-display"
        style={{
          backgroundColor: "#F3F3F3",
          borderTop: "10px solid #0074A9",
          padding: "3rem 0",
          borderBottom: "10px solid rgb(0, 116, 169)",
        }}
      >
        <Container>
          <Row>
            <Col className="step-col">
              <h2>
                Getting Started with <span>ImproveYourHouse.com</span>
              </h2>
              <h4>
                Unlocking a stream of real opportunities with
                ImproveYourHouse.com is a breeze. Here's a step-by-step guide to
                kickstart your journey:
              </h4>
              <a href="https://improveyourhouse.com/register-home-pro">
                <img src={width >= 767 ? stepsDesktop : stepsMobile} />
              </a>
              {width < 767 && (
                <img src={stepsMobile3} style={{ paddingTop: "35%" }} />
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <ImageCopy
        imagePos="right"
        image={dashboardImg}
        headline={
          <>
            <span>Take a tour!</span> <br/>
            Here's what your Home Pro dashboard will look like.
          </>
        }
        ctaButton={{
          to: "https://improveyourhouse.com/register-home-pro",
          linkText: "Try it Out Today!",
        }}
      />
      <TestimonialsBlock
        testimonialArr={[
          {
            copy: "“I have found ImproveYourHouse Magazine to be the best print source in the Denver area for high quality, new business leads. Greg and his staff are a pleasure to work with, and they respond very quickly to my questions and changes.”",
            testimonyGiver: "Mike, Garage Storage Solutions",
          },
          {
            copy: "“ImproveYourHouse Magazine has definitely helped me reach some customers that I would not of reached in the past. The demographics that this magazine hits has been good for super sales.”",
            testimonyGiver: "Paul, Innovative Painting",
          },
          {
            copy: "“Our business relies heavily on the lead traffic created by the ImproveYourHouse Magazine. We have partnered with Greg and ImproveYourHouse for 3 years now and highly recommend them. This is a quality product that generates quality leads.”",
            testimonyGiver: "Kathleen, Denver Doors & Closets",
          },
          
        ]}
        header={
          <>
            Real Success, <span>Real Results</span>
          </>
        }
        subhead="Don't take our word for it. Hear it from our Home Pros—we handle the heavy lifting, you get the work!"
      />
      <div className="partners-wrap">
        <div className="ribbon-text">
          <h2>
            Trusted{"  "}<span>Partners</span>
          </h2>
        </div>
        <Container>
          <Row>
            {logos.map((logo) => {
              return (
                <Col xs={4} md={3} className="logo-col">
                  <div>
                    <img src={logo} />
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
      <CtaBlock
        header={
          <>
            Are you a <span>home improvement contractor</span>{" "}
            ready to get to work?
          </>
        }
        link={{
          to: "https://improveyourhouse.com/register-home-pro",
          linkText: "Become a Home Pro",
        }}
      />
      {/* <article className='inner'>
				<Link to="/register-home-pro">Sign Up Now</Link>
			</article> */}
    </section>
  );
};

export default Contractor;
